import React from 'react'

import logo from './logo.svg'

function Logo(props: React.ComponentPropsWithoutRef<'img'>) {
  return <img src={logo} alt='Pet Notify' height='37' {...props} />
}

export default Logo
